import { faTrashAlt } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useDispatch } from 'react-redux';
import { actions } from '../../../../context';
import Split from '../../../Shared/Split';

const Domain = ({ domainId, domainName, refresh, locked = true }) => {
    const dispatch = useDispatch();
    const deleteDomain = () =>
        dispatch(actions.admin.deletePartnerDomain(domainId)).then(() =>
            refresh()
        );
    return (
        <Split className="mb-2">
            <h5>{domainName}</h5>
            {!locked && (
                <FontAwesomeIcon className="pop-hover" size="lg" icon={faTrashAlt} onClick={deleteDomain} />
            )}
        </Split>
    );
};

export default Domain;
